import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "row"
};
const _hoisted_2 = {
  class: "col-12"
};
const _hoisted_3 = {
  class: "mb-3"
};
const _hoisted_4 = {
  class: "col-12"
};
const _hoisted_5 = {
  class: "mb-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback");
  const _component_b_input_group = _resolveComponent("b-input-group");
  const _component_b_overlay = _resolveComponent("b-overlay");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_b_modal, {
    modelValue: _ctx.open,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.open = $event),
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    "no-header": "",
    busy: _ctx.loading
  }, {
    header: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" Please Change Your Password ", -1)]))]),
    footer: _withCtx(() => [_createVNode(_component_b_button, {
      onClick: _cache[4] || (_cache[4] = $event => $options.submit()),
      disabled: !_ctx.$v.$anyDirty || _ctx.$v.user.$anyError || _ctx.loading
    }, {
      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("Submit", -1)]))], undefined, true),
      _: 1
    }, 8, ["disabled"])]),
    default: _withCtx(() => [_createVNode(_component_b_overlay, {
      show: _ctx.loading
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[7] || (_cache[7] = _createElementVNode("label", {
        class: "control-label",
        for: "password"
      }, "Password:", -1)), _createVNode(_component_b_input_group, null, {
        default: _withCtx(() => [_createVNode(_component_b_form_input, {
          type: "password",
          modelValue: _ctx.user.password,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.user.password = $event),
          state: !_ctx.$v.user.password.$error ? null : false,
          onBlur: _cache[1] || (_cache[1] = $event => _ctx.$v.user.password.$touch()),
          name: "password",
          id: "password",
          required: "",
          minlength: "6",
          placeholder: "New Password",
          autocomplete: "new-password"
        }, null, 8, ["modelValue", "state"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getErrors('user', 'password', ['required', 'minLength']), err => {
          return _openBlock(), _createBlock(_component_b_form_invalid_feedback, {
            key: err.id
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(err), 1)], undefined, true),
            _: 2
          }, 1024);
        }), 128))], undefined, true),
        _: 1
      })])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[8] || (_cache[8] = _createElementVNode("label", {
        class: "control-label"
      }, "Password Confirm:", -1)), _createVNode(_component_b_input_group, null, {
        default: _withCtx(() => [_createVNode(_component_b_form_input, {
          type: "password",
          modelValue: _ctx.user.password2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.user.password2 = $event),
          state: !_ctx.$v.user.password2.$error ? null : false,
          onBlur: _cache[3] || (_cache[3] = $event => _ctx.$v.user.password2.$touch()),
          name: "password2",
          id: "password2",
          required: "",
          placeholder: "New Password Confirm",
          autocomplete: "new-password"
        }, null, 8, ["modelValue", "state"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getErrors('user', 'password2', ['required', 'sameAsPassword']), err => {
          return _openBlock(), _createBlock(_component_b_form_invalid_feedback, {
            key: err.id
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(err), 1)], undefined, true),
            _: 2
          }, 1024);
        }), 128))], undefined, true),
        _: 1
      })])])])], undefined, true),
      _: 1
    }, 8, ["show"])], undefined, true),
    _: 1
  }, 8, ["modelValue", "busy"])]);
}